import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import { H1 } from '../Heading/index'
import Link, { TARGET_BLANK } from '../Link/index'
import FilePdf from '../Icon/icons/FilePdf/index'
import Download from '../Icon/icons/Download/index'
import { ICON_COLORS } from '../Icon/index'
import LoadMore from '../LoadMore/index'

const MyLibraryPurchasesEBooks = (props) => {
  const {
    pageState,
    assetsList,
    staticText,
    fetchMore,
    loading,
    count = 0,
    totalCount = 0,
  } = props

  const renderItem = (asset, index) => (
    <div key={asset.get('uuid') || index} className="my-library__e-book">
      <div className="my-library__e-book-cover">
        <FilePdf size={42} color="#B03874" />
      </div>
      <div className="my-library__e-book-content">
        <p className="my-library__e-book-filename">
          {asset.get('originalFileName')}
        </p>
        <div className="my-library__e-book-meta">
          <Link
            directLink
            target={TARGET_BLANK}
            to={asset.get('renderUrl')}
            className="my-library__e-book-download"
          >
            <Download size={20} color={ICON_COLORS.TEAL} />
            <span className="my-library__e-book-meta-text">
              {staticText.get('download')}
            </span>
          </Link>
        </div>
      </div>
    </div>
  )

  return (
    <div className="my-library__content">
      <header className="my-library__playlist-header my-library__playlist-header--no-control">
        <H1>{pageState.name}</H1>
      </header>
      <div className="my-library__content-e-books-grid">
        {assetsList.map((asset, index) => renderItem(asset, index))}
      </div>
      <LoadMore
        onLoadMore={() => fetchMore({
          variables: {
            offset: count,
          },
        })}
        buttonClassName={['my-library__load-more-button', 'button--secondary']}
        currentCount={count}
        totalCount={totalCount}
        processing={loading || !assetsList.size}
        infiniteScroll
      />
    </div>
  )
}

MyLibraryPurchasesEBooks.propTypes = {
  pageState: PropTypes.object.isRequired,
  assetsList: ImmutablePropTypes.list.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  fetchMore: PropTypes.func,
  loading: PropTypes.bool,
  count: PropTypes.number,
  totalCount: PropTypes.number,
}

export default connect(
  (state) => {
    return {
      staticText: state.staticText.getIn(['data', 'myLibraryPage', 'data'], Map()) || Map(),
    }
  },
)(MyLibraryPurchasesEBooks)
